import { Button } from '@imprivata-cloud/components';
import { useTranslation } from 'react-i18next';
import SuccessSVG from '@assets/Success.svg?react';
import './EnrollmentCompletedCard.less';

interface EnrollmentCompletedCardProps {
  onDone: () => void;
}

export const EnrollmentCompletedCard = ({ onDone }: EnrollmentCompletedCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="root-enrollment-completed">
      <div className="content">
        <div className="success-svg">
          <SuccessSVG />
        </div>
        <h2 className="enroll-title">
          {t('self-service.enroll.completed.title', {
            authMethod: 'face',
          })}
        </h2>
      </div>
      <div className="enroll-buttons">
        <Button
          block
          aria-label="continue-button"
          type="primary"
          onClick={() => {
            console.log('Done clicked');
            onDone();
          }}
        >
          {t('common.done-button')}
        </Button>
      </div>
    </div>
  );
};
